module.exports = __webpack_public_path__ + "static/media/Checkmark.9e054856.svg";